<template>
  <div class="image-viewer">
    <img
      class="content"
      :src="src"
      role="button"
      @click="openModal"
    />
    <v-tooltip
        top
        content-class="custom-tooltip"
    >
      <template v-slot:activator="{ on, attrs }">
        <div
            class="bg-audio-flag"
            v-if="audioBg"
            v-bind="attrs"
            v-on="on"
        >
          <img class="bg-audio-flag__icon" src="@/assets/icons/svg/note.png">
        </div>
      </template>
      <span>Изображение содержит фоновый звук</span>
    </v-tooltip>

    <v-dialog
        v-if="isModalOpen"
      v-model="isModalOpen"
      max-width="fit-content"
      @click.self="closeModal"
    >
      <div
        class="modal-content pa-3 d-flex flex-column justify-center"
        @click.stop
      >
        <v-icon
            class="close-btn"
            size="12"
            @click="closeModal"
        >
          $cross
        </v-icon>
        <audio
            ref="audio"
            :src="getFileUrl(audioBg)"
            loop
            :autoplay="true"
        />
        <div class="d-flex justify-center align-center">
          <v-tooltip
              top
              content-class="custom-tooltip"
          >
            <template v-slot:activator="{ on, attrs }">
              <div
                  class="bg-audio-flag__dialog"
                  v-if="audioBg"
                  v-bind="attrs"
                  v-on="on"
              >
                <img class="bg-audio-flag__icon" src="@/assets/icons/svg/note.png">
              </div>
            </template>
            <span>Изображение содержит фоновый звук</span>
          </v-tooltip>

          <div class="button-divider ml-5" v-if="time_restriction_media">
            <div class="button-divider__content">
              <div class="toggle-button">
                {{ timeLeftMedia > 0 ? `🔥  Медиа исчезнет через ${secondsToHMS(timeLeftMedia)}` : 'Медиа скрыты' }}
              </div>
            </div>
          </div>
        </div>
        <div class="image-block pa-6">
          <img
              :src="src"
              class="modal-image"
          >
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import {secondsToHMS} from "@/assets/helpers/date";
import { getFileUrl } from "@/assets/helpers/getFileUrl";

export default {
  name: "m-image-viewer",
  props: {
    src: {
      type: String,
      default: ''
    },
    audioBg: {
      type: Object,
      default: null,
    },
    time_restriction_media: {
      type: Boolean,
      default: false
    },
    timeLeftMedia: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isModalOpen: false,
    }
  },
  methods: {
    secondsToHMS,
    getFileUrl,
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
  },
}
</script>

<style lang="scss" scoped>
.image-viewer{
  position: relative;
}

.modal-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fefefe;
  border: 1px solid #888;
  padding: 0;
  border-radius: 12px;
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  color: var(--basic-grey);
  z-index: 10;
}

.modal-image {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100vh;
  border-radius: 6px;
}

.image-block{
  border-radius: 6px;
  overflow: hidden;
}

.mh-inherit {
  max-height: inherit;
}

.content {
  width: 100%;
  border-radius: 10px;
  max-height: 160px;
}

.bg-audio-flag{
  background-color: white;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 4px 30px 0px #3334361A;

  &__icon{
    height: 13px;
    width: 13px;
  }
}

.bg-audio-flag__dialog{
  background-color: white;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 4px 30px 0px #3334361A;

  &__icon{
    height: 13px;
    width: 13px;
  }
}

.button-divider {
  position: relative;
  display: flex;
}


.toggle-button {
  position: relative;
  z-index: 1;
  border-radius: 30px;
  padding: 4px 12px;
  background-color: white;
  display: inline-flex;
  align-items: center;
  transition: background-color 0.2s;
  height: 26px;

  box-shadow: 0px 4px 30px 0px #3334361A;

  font-family: Open Sans;
  font-weight: 400;
  font-style: Regular;
  font-size: 11px;
  leading-trim: NONE;
  line-height: 130%;
  letter-spacing: 0%;
  color: var(--black);
}

.toggle-button:hover {
  background-color: #f5f5f5;
}
</style>